import { jsx, jsxs } from 'react/jsx-runtime';

const CheckIcon = (jsx("svg", { width: "14", height: "12", viewBox: "0 0 17 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { d: "M16.4766 0.333984C16.8105 0.705078 16.8105 1.26172 16.4766 1.5957L6.67969 11.3926C6.30859 11.7637 5.75195 11.7637 5.41797 11.3926L0.371094 6.3457C0 6.01172 0 5.45508 0.371094 5.12109C0.705078 4.75 1.26172 4.75 1.5957 5.12109L6.01172 9.53711L15.2148 0.333984C15.5488 0 16.1055 0 16.4395 0.333984H16.4766Z", fill: "var(--color-input-icon-selected)" }) }));
const styles = {
    inputLabel: 'flex items-center gap-space-200 cursor-pointer',
    label: 'block items-center text-balance',
    base: 'flex items-center justify-center w-5 h-5 border-1 rounded transition-colors',
    disabled: 'border-input-border-disabled bg-input-bg-disabled text-neutral-500', // TODO Replace with generic disabled or checkbox component specific disabled styles
};
const Checkbox = ({ checked, onChange, label, disabled = false }) => {
    const buildLabel = () => {
        if (typeof label === 'string') {
            return jsx("span", { className: styles.label, children: label });
        }
        else {
            return label;
        }
    };
    return (jsxs("label", { className: `${styles.inputLabel} ${disabled ? styles.disabled : ''}`, children: [jsx("input", { type: "checkbox", checked: checked, onChange: onChange, disabled: disabled, className: "sr-only" }), jsx("div", { className: `${styles.base} ${disabled ? styles.disabled : ''}`, children: jsx("div", { className: `
            flex items-center justify-center w-4 h-4
            transition-all duration-200
            ${checked ? 'opacity-100' : 'opacity-0'}
          `, children: CheckIcon }) }), label && buildLabel()] }));
};

export { Checkbox };
